import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { findFee, Modal, TerminateFeeDetails, TerminateFeeDetails$reflection, Fee$reflection, convertFeeToViewModel, EditFeeRowViewModel$reflection } from "./Model.js";
import { option_type, class_type, bool_type, record_type, tuple_type, unit_type, list_type, int32_type, lambda_type, string_type, union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { ofArray, isEmpty, head as head_3, unfold, map as map_1, tryFind, singleton as singleton_1, append as append_1 } from "../../fable_modules/fable-library.3.7.20/List.js";
import { logei, Locale_get_FromSelectedLanguage, classNames, DateTimeExtensions_yyyy_MM_dd, DateOnlyExtensions_to1stInMonth, DateOnlyExtensions_yyyy_MM_dd, Locale$reflection, parseDecimal, parseInt$, DateTimeExtensions_toDate, DateOnlyExtensions_toDate, decimalToTwoDecimals } from "../../Utils.js";
import { op_Division, fromParts, op_Addition, op_Multiply } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import Decimal from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import * as react from "react";
import { value as value_11, bind, defaultArg, map } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { partialApply, equals, uncurry, max, int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { separateByThousands } from "../../Utilities/String.js";
import { isNullOrWhiteSpace, toFail, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { PageinationProps$1, Pagination } from "../../Components/Pagination/Pagination.js";
import { renderDotMenuAreaTable } from "../../Components/Table/Table.js";
import { getModalBodyContainer, getModalHeader, ModalSize, getModalContainer, modal } from "../../Components/Modal/Modal.js";
import { render as render_1 } from "../../Components/Modals/Choice/Choice.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { parse, addMonths, addDays, minValue, compare, now } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { dotsLoading, getMaterialIcon, getWrappedMaterialIcon } from "../../ViewUtils.js";
import { DateModule_today, DateModule_ofDateTime, DateModule_toDateTime } from "../../Svea.Dry/Time.js";
import { RadioInput, RadioInput_get_getDefault, inputRadio, SelectOption, ValueProp as ValueProp_3, SelectOption_get_getDefault, selectOption, CheckboxInput, CheckboxInput_get_getDefault, inputCheckbox, DateOptions, DateOptions_get_getDefault, inputDate } from "../../Components/FormFields/FormFields.js";
import { EnableTimePicker, EnableRanges, Value as Value_2, Locale as Locale_1, FormatDateBy, DisableRanges, Id as Id_8, OnChange as OnChange_3, Placeholder } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { Browser_Types_Event__Event_get_Value, Browser_Types_Event__Event_get_Checked } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { ButtonKind, wrappedButton, modalMain, ButtonProps, defaultProps, modalCancel } from "../../Components/Button/Button.js";
import { warning, info, error } from "../../Components/Message/Message.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { useSelector } from "../../Redux/Store.js";
import { GlobalDependencies$reflection, LoadState$2, getTranslationFrom } from "../../Global.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { parse as parse_1, toDateTime, fromDateTime } from "../../fable_modules/fable-library.3.7.20/DateOnly.js";
import { create } from "../../fable_modules/fable-library.3.7.20/TimeOnly.js";
import { primary } from "../../Components/Panel/Panel.js";
import { renderWithButtonProps } from "../../Components/Modals/Standard.js";
import { FeeFormViewModelValues, FeeFormViewModelValues$reflection, ChartOfAccount$reflection, FeeFormTemplate$reflection } from "../FeeModal/Model.js";
import { CancelDateChoice, PaymentMethod$reflection, IsoCountryCode$reflection } from "../../DomainTypes.js";
import { FeeVersion, FeeModalProps, renderFeeModal, getInitFeeViewModelValues, FeeType$reflection, FeeVersion$reflection } from "../FeeModal/View.js";
import { afterSomeTimeSelects, getVatRates, cancellationPeriodMonths as cancellationPeriodMonths_1 } from "../../CommonData.js";
import { parse as parse_2 } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { loadMaxBilledToNextTime as loadMaxBilledToNextTime_1, loadEarliestInvoiceDate as loadEarliestInvoiceDate_1 } from "./Api.js";
import "../../../src/Containers/FeesTable/View.scss";


export class RowType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["DisplayRow", "EditRow"];
    }
}

export function RowType$reflection() {
    return union_type("Containers.FeesTable.View.RowType", [], RowType, () => [[["Item", EditFeeRowViewModel$reflection()]], [["Item", EditFeeRowViewModel$reflection()]]]);
}

function getActiveFeesTableHeaders(getTranslation, showUnitAndUnitPrice) {
    return toList(delay(() => append(singleton(getTranslation("Common.FeeText")), delay(() => append(showUnitAndUnitPrice ? singleton(getTranslation("Common.Units")) : empty(), delay(() => append(showUnitAndUnitPrice ? singleton(getTranslation("Common.Price")) : singleton(getTranslation("Common.AmountExclVat")), delay(() => append(singleton(getTranslation("Common.AmountInclVat")), delay(() => append(singleton(getTranslation("Common.StartDate")), delay(() => append(singleton(getTranslation("Common.EndDate")), delay(() => append(singleton(getTranslation("Containers.FeesTable.BoundMonths")), delay(() => singleton(getTranslation("Containers.FeesTable.InvoicePeriod"))))))))))))))))));
}

export function getInactiveFeesTableHeaders(getTranslation, showUnitAndUnitPrice) {
    return append_1(getActiveFeesTableHeaders(getTranslation, showUnitAndUnitPrice), singleton_1(getTranslation("Containers.FeesTable.Status")));
}

export function getAmountIncludingVat(vatRatePercent, amountExcludingVat) {
    return decimalToTwoDecimals(op_Multiply(amountExcludingVat, op_Addition(fromParts(100, 0, 0, false, 2), op_Division(vatRatePercent, fromParts(10000, 0, 0, false, 2)))));
}

export function getExpandableAreaHtml(fees, getTranslation, vmOpt, locale, clientNr) {
    const renderExpandAreaRow = (translationKey, valueStr) => {
        let children;
        const children_4 = [(children = [getTranslation(translationKey)], react.createElement("td", {
            className: "row__cell",
            ["data-translation"]: translationKey,
        }, ...children)), react.createElement("td", {
            className: "row__cell",
        }, valueStr)];
        return react.createElement("tr", {
            className: "expand-area__row",
        }, ...children_4);
    };
    return map((vm) => {
        let children_10, children_8, children_16, children_14, children_26, children_20, children_24;
        const vatRatePercentRowHtml = renderExpandAreaRow("Common.VAT", vm.VatRatePercent + "%");
        const monthsInAdvanceRowHtml = renderExpandAreaRow("Containers.FeesTable.MonthsInAdvance", vm.MonthsInAdvance);
        const cancellationPeriodMonthsHtml = renderExpandAreaRow("Containers.FeesTable.CancellationPeriod", int32ToString(vm.CancellationPeriodMonths));
        const feeNumberHtml = renderExpandAreaRow("Common.FeeNumber", int32ToString(vm.FeeNumber));
        const feeTemplateNrHtml = renderExpandAreaRow("Containers.FeesTable.FeeTemplateNr", vm.FeeTemplateNr);
        const feeTemplateNameHtml = renderExpandAreaRow("Containers.FeesTable.FeeTemplateName", vm.FeeTemplateDescription);
        const boundToHtml = renderExpandAreaRow("Containers.FeesTable.BoundTo", DateOnlyExtensions_toDate(locale, vm.BoundTo));
        const boundMonthsHtml = renderExpandAreaRow("Containers.FeesTable.BoundMonths", vm.BoundMonths);
        const remainingBoundMonthsHtml = renderExpandAreaRow("Containers.FeesTable.RemainingBoundMonths", int32ToString(defaultArg(map((f_1) => f_1.RemainingBoundMonths, tryFind((f) => (f.FeeNumber === vm.FeeNumber), fees)), 0)));
        const billedToHtml = renderExpandAreaRow("Containers.FeesTable.BilledTo", defaultArg(map((billedToDate) => DateOnlyExtensions_toDate(locale, billedToDate), vm.BilledTo), "-"));
        const createdTimeHtml = renderExpandAreaRow("Containers.FeesTable.Created", DateTimeExtensions_toDate(locale, vm.CreatedTime) + ((vm.CreatedBy.trim() === "") ? "" : (" " + vm.CreatedBy)));
        const children_28 = [(children_10 = [(children_8 = [react.createElement("tbody", {}, vatRatePercentRowHtml, feeNumberHtml, feeTemplateNrHtml, feeTemplateNameHtml)], react.createElement("table", {}, ...children_8))], react.createElement("div", {}, ...children_10)), (children_16 = [(children_14 = [react.createElement("tbody", {}, monthsInAdvanceRowHtml, cancellationPeriodMonthsHtml, boundToHtml, remainingBoundMonthsHtml, boundMonthsHtml)], react.createElement("table", {}, ...children_14))], react.createElement("div", {}, ...children_16)), (children_26 = [(children_20 = [react.createElement("tbody", {}, billedToHtml)], react.createElement("table", {}, ...children_20)), (children_24 = [react.createElement("tbody", {}, createdTimeHtml)], react.createElement("table", {}, ...children_24))], react.createElement("div", {
            className: "d-flex flex-column justify-content-between",
        }, ...children_26))];
        return react.createElement("div", {
            className: "fees__expand-area",
        }, ...children_28);
    }, vmOpt);
}

function getEditFeeRowViewModel(getTranslation, locale, feeNr, feeTemplates, fees) {
    return map((fee_1) => convertFeeToViewModel(getTranslation, locale, feeTemplates, fee_1), bind((feeNr_1) => tryFind((fee) => (fee.FeeNumber === feeNr_1), fees), bind(parseInt$, feeNr)));
}

function renderFeesTable(getTranslation, expandAreaRowId, fees, feeTemplates, dotMenu, onRowClick, locale, showUnitAndUnitPrice, clientNr) {
    const rows = map_1((arg_3) => {
        let vatRatePercentOpt, amountExclVatOpt;
        const feeViewModel = convertFeeToViewModel(getTranslation, locale, feeTemplates, arg_3);
        const unitsHtml = int32ToString(feeViewModel.Units);
        const unitPriceHtml = decimalToTwoDecimals(feeViewModel.UnitPrice);
        const amountExcludingVatHtml = separateByThousands(feeViewModel.Amount);
        const amountIncludingVatHtml = (vatRatePercentOpt = parseDecimal(feeViewModel.VatRatePercent), (amountExclVatOpt = parseDecimal(feeViewModel.Amount), separateByThousands(defaultArg(bind((x1) => map((amountExcludingVat) => getAmountIncludingVat(x1, amountExcludingVat), amountExclVatOpt), vatRatePercentOpt), "-"))));
        const remainingBoundMonths = defaultArg(map(int32ToString, map((f_9) => f_9.RemainingBoundMonths, tryFind((f_8) => (f_8.FeeNumber === feeViewModel.FeeNumber), fees))), "-");
        const boundMonthsHtml = (feeViewModel.BoundMonths === "0") ? feeViewModel.BoundMonths : toText(printf("%s (%s)"))(remainingBoundMonths)(feeViewModel.BoundMonths);
        return [toList(delay(() => append(singleton(feeViewModel.Description), delay(() => append(showUnitAndUnitPrice ? singleton(unitsHtml) : empty(), delay(() => append(showUnitAndUnitPrice ? singleton(unitPriceHtml) : singleton(amountExcludingVatHtml), delay(() => append(singleton(amountIncludingVatHtml), delay(() => append(singleton(feeViewModel.StartDate), delay(() => append(singleton(feeViewModel.EndDate), delay(() => append(singleton(boundMonthsHtml), delay(() => singleton(feeViewModel.Period))))))))))))))))), int32ToString(feeViewModel.FeeNumber)];
    }, fees);
    const displayFeeOpt = getEditFeeRowViewModel(getTranslation, locale, expandAreaRowId, feeTemplates, fees);
    return Pagination()(new PageinationProps$1((rows_1) => renderDotMenuAreaTable(getActiveFeesTableHeaders(getTranslation, showUnitAndUnitPrice), rows_1, (_arg) => dotMenu, getExpandableAreaHtml(fees, getTranslation, displayFeeOpt, locale.ILocale, clientNr), expandAreaRowId, onRowClick), rows, 10, 0));
}

function annulFeeModalHtml(getTranslation, feeNumber, closeModalFn, saveAnnulFeeFn) {
    let modalBodyHtml;
    const children = [getTranslation("Containers.FeesTable.AnnulFee.BodyText")];
    modalBodyHtml = react.createElement("div", {
        className: "color-black mb-4",
    }, ...children);
    return modal(true, getModalContainer(new ModalSize(1), render_1(getTranslation("Containers.FeesTable.AnnulFee.AnnulFee"), modalBodyHtml, getTranslation("Containers.FeesTable.AnnulFee.Cancel"), getTranslation("Containers.FeesTable.AnnulFee"), (_arg) => {
        closeModalFn();
    }, (_arg_1) => {
        saveAnnulFeeFn(feeNumber);
    })));
}

class TerminateFeeModalProps extends Record {
    constructor(GetTranslation, FeeNumber, Fees, Locale, CloseModalFn, SaveTerminateFeeFn) {
        super();
        this.GetTranslation = GetTranslation;
        this.FeeNumber = (FeeNumber | 0);
        this.Fees = Fees;
        this.Locale = Locale;
        this.CloseModalFn = CloseModalFn;
        this.SaveTerminateFeeFn = SaveTerminateFeeFn;
    }
}

function TerminateFeeModalProps$reflection() {
    return record_type("Containers.FeesTable.View.TerminateFeeModalProps", [], TerminateFeeModalProps, () => [["GetTranslation", lambda_type(string_type, string_type)], ["FeeNumber", int32_type], ["Fees", list_type(Fee$reflection())], ["Locale", Locale$reflection()], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["SaveTerminateFeeFn", lambda_type(tuple_type(Fee$reflection(), TerminateFeeDetails$reflection()), unit_type)]]);
}

const renderTerminateFeeModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let matchValue, fee_1, cancellationPeriodInfoHtml, children_7, children_3, children_5, arg_3, arg_1, boundMonthsWarningHtml, children_14, children_10, children_12, arg_5, arg_4, modalBodyHtml, children_25, children_17, inputRecord, LabelText, children_19, inputRecord_1, inputRecord_2, children_21, arg_10, terminateFeeDetails, boundMonths_1, cancellationMonths, cancellationDate, arg_9, modalFooterHtml, children_27, children_2, children;
    const dateState = react.useState(now());
    const removeCancellationPeriodState = react.useState(false);
    const removeBoundMonthsState = react.useState(false);
    const modalHeaderHtml = getModalHeader(props.GetTranslation("Containers.FeesTable.TerminateFee"), (_arg) => {
        props.CloseModalFn();
    });
    return modal(true, getModalContainer(new ModalSize(1), (matchValue = tryFind((fee) => (fee.FeeNumber === props.FeeNumber), props.Fees), (matchValue != null) ? ((fee_1 = matchValue, (cancellationPeriodInfoHtml = ((fee_1.CancellationPeriodMonths > 0) ? ((children_7 = [(children_3 = [getWrappedMaterialIcon("info")], react.createElement("div", {
        className: "messages__info-icon",
    }, ...children_3)), (children_5 = [(arg_3 = ((fee_1.CancellationPeriodMonths === 1) ? props.GetTranslation("Containers.FeesTable.FeeForm.Month") : props.GetTranslation("Containers.FeesTable.FeeForm.Months")), (arg_1 = props.GetTranslation("Containers.FeesTable.CancellationPeriod"), toText(printf("%s: %i %s."))(arg_1)(fee_1.CancellationPeriodMonths)(arg_3)))], react.createElement("div", {
        className: "messages__text",
        ["data-translation"]: "Containers.FeesTable.BoundMonthsWarning",
    }, ...children_5))], react.createElement("div", {
        className: "fees__messages",
    }, ...children_7))) : react.createElement(react.Fragment, {})), (boundMonthsWarningHtml = ((compare(DateModule_toDateTime(fee_1.BoundTo), dateState[0]) > 0) ? ((children_14 = [(children_10 = [getWrappedMaterialIcon("warning")], react.createElement("div", {
        className: "messages__warning-icon",
    }, ...children_10)), (children_12 = [(arg_5 = DateTimeExtensions_toDate(props.Locale.ILocale, DateModule_toDateTime(fee_1.BoundTo)), (arg_4 = props.GetTranslation("Containers.FeesTable.BoundMonthsWarning"), toText(printf("%s (%s)."))(arg_4)(arg_5)))], react.createElement("div", {
        className: "messages__text",
        ["data-translation"]: "Containers.FeesTable.BoundMonthsWarning",
    }, ...children_12))], react.createElement("div", {
        className: "fees__messages",
    }, ...children_14))) : react.createElement(react.Fragment, {})), (modalBodyHtml = getModalBodyContainer((children_25 = [(children_17 = [inputDate((inputRecord = DateOptions_get_getDefault(), (LabelText = props.GetTranslation("Containers.FeesTable.CancellationDate"), new DateOptions(toList(delay(() => append(singleton(Placeholder(props.GetTranslation("Containers.FeesTable.Choose"))), delay(() => append(singleton(OnChange_3((arg_6) => {
        dateState[1](arg_6);
    })), delay(() => append(singleton(Id_8("terminate-fee-date-picker")), delay(() => {
        let copyOfStruct;
        return append((fee_1.BilledTo != null) ? singleton(DisableRanges(singleton_1([minValue(), (copyOfStruct = DateModule_toDateTime(value_11(fee_1.BilledTo)), addDays(copyOfStruct, -1))]))) : empty(), delay(() => append(singleton(FormatDateBy((date_1) => DateTimeExtensions_toDate(props.Locale.ILocale, date_1))), delay(() => append(singleton(Locale_1(props.Locale.FlatpickrLocale)), delay(() => singleton(Value_2(dateState[0]))))))));
    })))))))), LabelText, true, inputRecord.Disabled, inputRecord.OnClearClick))))], react.createElement("div", {
        ["data-translation"]: "Containers.FeesTable.CancellationDate",
    }, ...children_17)), (children_19 = [inputCheckbox((inputRecord_1 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_1.Disabled, props.GetTranslation("Containers.FeesTable.RemoveCancellationPeriod"), (e) => {
        const arg_7 = Browser_Types_Event__Event_get_Checked(e);
        removeCancellationPeriodState[1](arg_7);
    }, removeCancellationPeriodState[0], "remove-cancellation-period", inputRecord_1.HTMLProps))), inputCheckbox((inputRecord_2 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_2.Disabled, props.GetTranslation("Containers.FeesTable.RemoveBoundMonths"), (e_1) => {
        const arg_8 = Browser_Types_Event__Event_get_Checked(e_1);
        removeBoundMonthsState[1](arg_8);
    }, removeBoundMonthsState[0], "remove-bound-months", inputRecord_2.HTMLProps)))], react.createElement("div", {
        className: "mt-2 ml-1",
    }, ...children_19)), (children_21 = [(arg_10 = ((terminateFeeDetails = (new TerminateFeeDetails(dateState[0], removeCancellationPeriodState[0], removeBoundMonthsState[0])), (boundMonths_1 = ((terminateFeeDetails.RemoveBoundMonths ? 0 : fee_1.BoundMonths) | 0), (cancellationMonths = ((terminateFeeDetails.RemoveCancellationPeriod ? 0 : fee_1.CancellationPeriodMonths) | 0), DateTimeExtensions_toDate(props.Locale.ILocale, DateModule_toDateTime((cancellationDate = addMonths(DateModule_ofDateTime(terminateFeeDetails.Date), cancellationMonths), max(compare, addMonths(fee_1.StartDate, boundMonths_1), cancellationDate)))))))), (arg_9 = props.GetTranslation("Containers.FeesTable.EstimatedEndDate"), toText(printf("%s: %s"))(arg_9)(arg_10)))], react.createElement("div", {
        className: "color-black mt-3 mb-4",
    }, ...children_21)), react.createElement("div", {
        className: "mt-3",
    }, cancellationPeriodInfoHtml, boundMonthsWarningHtml)], react.createElement("div", {}, ...children_25))), (modalFooterHtml = ((children_27 = [modalCancel(new ButtonProps(props.GetTranslation("Containers.FeesTable.Cancel"), defaultProps.Content, (_arg_1) => {
        props.CloseModalFn();
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), modalMain(new ButtonProps(props.GetTranslation("Containers.FeesTable.TerminateFee"), defaultProps.Content, (_arg_2) => {
        props.SaveTerminateFeeFn([fee_1, new TerminateFeeDetails(dateState[0], removeCancellationPeriodState[0], removeBoundMonthsState[0])]);
        props.CloseModalFn();
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement("div", {
        className: "d-flex",
    }, ...children_27))), react.createElement(react.Fragment, {}, modalHeaderHtml, modalBodyHtml, modalFooterHtml))))))) : ((children_2 = [modalHeaderHtml, getModalBodyContainer((children = [error(toText(printf("Cannot find fee with FeeNumber %i. This is an error on our side, please contact support."))(props.FeeNumber).split(""))], react.createElement("div", {}, ...children)))], react.createElement(react.Fragment, {}, ...children_2))))));
}, void 0, uncurry(2, void 0), void 0, "renderTerminateFeeModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FeesTable\\View.fs", 426);

class EditInvoicingModalProps extends Record {
    constructor(Fee, HasCardPayment, Locale, CloseModalFn, SaveBilledToFn, SaveEarliestInvoiceDateFn, SaveMaxBilledToNextTimeFn, LoadEarliestInvoiceDateFn, LoadMaxBilledToNextTimeFn) {
        super();
        this.Fee = Fee;
        this.HasCardPayment = HasCardPayment;
        this.Locale = Locale;
        this.CloseModalFn = CloseModalFn;
        this.SaveBilledToFn = SaveBilledToFn;
        this.SaveEarliestInvoiceDateFn = SaveEarliestInvoiceDateFn;
        this.SaveMaxBilledToNextTimeFn = SaveMaxBilledToNextTimeFn;
        this.LoadEarliestInvoiceDateFn = LoadEarliestInvoiceDateFn;
        this.LoadMaxBilledToNextTimeFn = LoadMaxBilledToNextTimeFn;
    }
}

function EditInvoicingModalProps$reflection() {
    return record_type("Containers.FeesTable.View.EditInvoicingModalProps", [], EditInvoicingModalProps, () => [["Fee", Fee$reflection()], ["HasCardPayment", bool_type], ["Locale", Locale$reflection()], ["CloseModalFn", lambda_type(unit_type, unit_type)], ["SaveBilledToFn", lambda_type(option_type(class_type("System.DateOnly")), unit_type)], ["SaveEarliestInvoiceDateFn", lambda_type(option_type(class_type("System.DateOnly")), unit_type)], ["SaveMaxBilledToNextTimeFn", lambda_type(option_type(class_type("System.DateOnly")), unit_type)], ["LoadEarliestInvoiceDateFn", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(class_type("System.DateOnly")), string_type], FSharpResult$2, () => [[["ResultValue", option_type(class_type("System.DateOnly"))]], [["ErrorValue", string_type]]])]))], ["LoadMaxBilledToNextTimeFn", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(class_type("System.DateOnly")), string_type], FSharpResult$2, () => [[["ResultValue", option_type(class_type("System.DateOnly"))]], [["ErrorValue", string_type]]])]))]]);
}

class RadioChoice extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ChangeBilledTo", "SetEarliestInvoiceDate", "SetMaxBilledToNextTime"];
    }
}

function RadioChoice$reflection() {
    return union_type("Containers.FeesTable.View.RadioChoice", [], RadioChoice, () => [[], [], []]);
}

function RadioChoice_get_ChangeBilledToString() {
    return "ChangeBilledTo";
}

function RadioChoice_get_SetEarliestInvoiceDateString() {
    return "SetEarliestInvoiceDate";
}

function RadioChoice_get_SetMaxBilledToNextTimeString() {
    return "SetMaxBilledToNextTime";
}

function RadioChoice_get_ToString() {
    return (_arg) => ((_arg.tag === 1) ? RadioChoice_get_SetEarliestInvoiceDateString() : ((_arg.tag === 2) ? RadioChoice_get_SetMaxBilledToNextTimeString() : RadioChoice_get_ChangeBilledToString()));
}

function RadioChoice_get_FromString() {
    return (_arg) => ((_arg === RadioChoice_get_ChangeBilledToString()) ? (new RadioChoice(0)) : ((_arg === RadioChoice_get_SetEarliestInvoiceDateString()) ? (new RadioChoice(1)) : ((_arg === RadioChoice_get_SetMaxBilledToNextTimeString()) ? (new RadioChoice(2)) : toFail(printf("[RadioChoice - FromString] Cannot convert %s to RadioChoice"))(_arg))));
}

const renderEditInvoicingModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let copyOfStruct, copyOfStruct_1, children_2, children_4, children_6, arg_6, arg_7, inputRecord_1, Disabled_1, inputRecord, children_20, children_25, arg_11, inputRecord_2, children_39, children_44, arg_13, inputRecord_3, children_58, inputRecord_4, RadioValue, IsChecked, inputRecord_5, RadioValue_1, IsChecked_1, inputRecord_6, RadioValue_2, IsChecked_2;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const billedToDateState = react.useState(defaultArg(map(DateOnlyExtensions_yyyy_MM_dd, map(DateOnlyExtensions_to1stInMonth, props.Fee.BilledTo)), ""));
    const enableBilledToDateChangeState = react.useState(false);
    const enableEarliestInvoiceDateChangeState = react.useState(false);
    const enableMaxBilledToNextTimeChangeState = react.useState(false);
    const radioChoiceState = react.useState(new RadioChoice(0));
    const earliestInvoiceDateLoadState = react.useState(new LoadState$2(0));
    const maxBilledToNextTimeLoadState = react.useState(new LoadState$2(0));
    const earliestInvoiceDateState = react.useState("");
    const maxBilledToNextTimeState = react.useState("");
    react.useEffect(() => {
        earliestInvoiceDateLoadState[1](new LoadState$2(1));
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(props.LoadEarliestInvoiceDateFn(), (_arg) => {
            const result = _arg;
            let arg_1;
            if (result.tag === 1) {
                arg_1 = (new LoadState$2(3, result.fields[0]));
            }
            else {
                const earliestInvoiceDate = result.fields[0];
                const arg = defaultArg(map(DateOnlyExtensions_yyyy_MM_dd, map(DateOnlyExtensions_to1stInMonth, earliestInvoiceDate)), "");
                earliestInvoiceDateState[1](arg);
                arg_1 = (new LoadState$2(2, earliestInvoiceDate));
            }
            earliestInvoiceDateLoadState[1](arg_1);
            return singleton_2.Zero();
        })));
    }, []);
    react.useEffect(() => {
        maxBilledToNextTimeLoadState[1](new LoadState$2(1));
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(props.LoadMaxBilledToNextTimeFn(), (_arg_1) => {
            const result_1 = _arg_1;
            let arg_4;
            if (result_1.tag === 1) {
                arg_4 = (new LoadState$2(3, result_1.fields[0]));
            }
            else {
                const maxBilledToNextTime = result_1.fields[0];
                const arg_3 = defaultArg(map(DateOnlyExtensions_yyyy_MM_dd, map(DateOnlyExtensions_to1stInMonth, maxBilledToNextTime)), "");
                maxBilledToNextTimeState[1](arg_3);
                arg_4 = (new LoadState$2(2, maxBilledToNextTime));
            }
            maxBilledToNextTimeLoadState[1](arg_4);
            return singleton_2.Zero();
        })));
    }, []);
    const billedToStartDate = DateOnlyExtensions_to1stInMonth(addMonths(defaultArg(props.Fee.BilledTo, fromDateTime(now())), -12));
    const billedToEndDate = addMonths(billedToStartDate, 25);
    const generateDates = (startDate, endDate) => unfold((date_8) => {
        if (compare(date_8, endDate) >= 0) {
            return void 0;
        }
        else {
            return [[DateOnlyExtensions_yyyy_MM_dd(date_8), DateOnlyExtensions_yyyy_MM_dd(date_8)], addMonths(date_8, 1)];
        }
    }, startDate);
    const billedToDateOptions = append_1(singleton_1(["", getTranslation("Common.Nothing")]), generateDates(billedToStartDate, billedToEndDate));
    let earliestInvoiceDateOptions;
    const earliestDate = DateOnlyExtensions_to1stInMonth((copyOfStruct = DateModule_today(), addMonths(copyOfStruct, 1)));
    const latestDate = addMonths(earliestDate, 13);
    earliestInvoiceDateOptions = append_1(singleton_1(["", getTranslation("Common.Nothing")]), generateDates(earliestDate, latestDate));
    let maxBilledToNextTimeOptions;
    const maxBilledToNextTime_1 = DateOnlyExtensions_to1stInMonth((copyOfStruct_1 = DateModule_today(), addMonths(copyOfStruct_1, 1)));
    const latestDate_1 = addMonths(maxBilledToNextTime_1, 13);
    maxBilledToNextTimeOptions = append_1(singleton_1(["", getTranslation("Common.Nothing")]), generateDates(maxBilledToNextTime_1, latestDate_1));
    let bodyHtml;
    let billedToHtml;
    let panelHeaderHtml;
    const children = [getTranslation("Containers.FeesTable.BilledToInfo1")];
    panelHeaderHtml = react.createElement("span", {
        className: "font-weight-bold",
    }, ...children);
    let panelBodyHtml;
    const children_8 = [(children_2 = [getTranslation("Containers.FeesTable.BilledToInfo2")], react.createElement("p", {}, ...children_2)), (children_4 = [getTranslation("Containers.FeesTable.BilledToInfo3")], react.createElement("p", {}, ...children_4)), (children_6 = [getTranslation("Containers.FeesTable.BilledToInfo4")], react.createElement("p", {}, ...children_6))];
    panelBodyHtml = react.createElement("div", {}, ...children_8);
    let invoicedToTextHtml;
    const children_10 = [(arg_6 = getTranslation("Containers.FeesTable.BilledTo"), toText(printf("%s: "))(arg_6))];
    invoicedToTextHtml = react.createElement("span", {}, ...children_10);
    let billedToTextHtml;
    const text = defaultArg(map(DateOnlyExtensions_yyyy_MM_dd, props.Fee.BilledTo), (arg_7 = getTranslation("Containers.FeesTable.NotBilled"), toText(printf("(%s)"))(arg_7)));
    billedToTextHtml = react.createElement("span", {}, text);
    let penIconHtml;
    if (enableBilledToDateChangeState[0]) {
        penIconHtml = react.createElement(react.Fragment, {});
    }
    else {
        const children_15 = [getMaterialIcon("edit")];
        penIconHtml = react.createElement("div", {
            id: "billed-to-pen",
            className: "billed-to__pen-icon",
            onClick: (_arg_2) => {
                enableBilledToDateChangeState[1](true);
                const matchValue_2 = [billedToDateState[0], billedToDateOptions];
                let pattern_matching_result;
                if (matchValue_2[0] === "") {
                    if (!isEmpty(matchValue_2[1])) {
                        pattern_matching_result = 0;
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        billedToDateState[1](head_3(matchValue_2[1])[0]);
                        break;
                    }
                    case 1: {
                        break;
                    }
                }
            },
        }, ...children_15);
    }
    let chooserHtml;
    const matchValue_3 = enableBilledToDateChangeState[0];
    chooserHtml = (matchValue_3 ? (props.HasCardPayment ? inputDate((inputRecord_1 = DateOptions_get_getDefault(), (Disabled_1 = equals(radioChoiceState[0], new RadioChoice(1)), new DateOptions(toList(delay(() => append(singleton(EnableRanges(singleton_1([toDateTime(billedToStartDate, create(0, 0)), toDateTime(billedToEndDate, create(0, 0))]))), delay(() => append(singleton(EnableTimePicker(false)), delay(() => append(singleton(Id_8("billed-to-select-date")), delay(() => append(singleton(FormatDateBy((date_12) => DateTimeExtensions_toDate(props.Locale.ILocale, date_12))), delay(() => append(singleton(Locale_1(props.Locale.FlatpickrLocale)), delay(() => append(isNullOrWhiteSpace(billedToDateState[0]) ? ((empty())) : singleton(Value_2(parse(billedToDateState[0]))), delay(() => singleton(OnChange_3((arg_10) => {
        const arg_9 = DateTimeExtensions_yyyy_MM_dd(arg_10);
        billedToDateState[1](arg_9);
    })))))))))))))))), inputRecord_1.LabelText, true, Disabled_1, inputRecord_1.OnClearClick)))) : selectOption((inputRecord = SelectOption_get_getDefault(), new SelectOption(new ValueProp_3(0, billedToDateState[0], (e) => {
        const arg_8 = Browser_Types_Event__Event_get_Value(e);
        billedToDateState[1](arg_8);
    }), "billed-to-select-month", billedToDateOptions, inputRecord.Classes, inputRecord.LabelText, equals(radioChoiceState[0], new RadioChoice(1)) ? true : equals(radioChoiceState[0], new RadioChoice(2)), inputRecord.HTMLProps)))) : react.createElement(react.Fragment, {}));
    billedToHtml = primary(panelHeaderHtml, panelBodyHtml, (children_20 = [invoicedToTextHtml, billedToTextHtml, penIconHtml, react.createElement("div", {
        className: "fit-content",
    }, chooserHtml)], react.createElement("div", {
        className: "billed-to__container-horizontal",
    }, ...children_20)));
    let earliestInvoiceDateHtml;
    const matchValue_5 = earliestInvoiceDateLoadState[0];
    switch (matchValue_5.tag) {
        case 1: {
            earliestInvoiceDateHtml = dotsLoading;
            break;
        }
        case 3: {
            earliestInvoiceDateHtml = error(matchValue_5.fields[0].split(""));
            break;
        }
        case 2: {
            let panelHeaderHtml_1;
            const children_23 = [getTranslation("Containers.FeesTable.EarliestInvoiceDateInfoText1")];
            panelHeaderHtml_1 = react.createElement("span", {
                className: "font-weight-bold",
            }, ...children_23);
            let panelBodyHtml_1;
            const children_27 = [(children_25 = [getTranslation("Containers.FeesTable.EarliestInvoiceDateInfoText2")], react.createElement("p", {}, ...children_25))];
            panelBodyHtml_1 = react.createElement("div", {}, ...children_27);
            let invoicedToTextHtml_1;
            const children_29 = [getTranslation("Containers.FeesTable.EarliestInvoiceDate") + ": "];
            invoicedToTextHtml_1 = react.createElement("span", {}, ...children_29);
            let earliestInvoiceDateTextHtml;
            const text_1 = defaultArg(map(DateOnlyExtensions_yyyy_MM_dd, matchValue_5.fields[0]), (arg_11 = getTranslation("Containers.FeesTable.NotSet"), toText(printf("(%s)"))(arg_11)));
            earliestInvoiceDateTextHtml = react.createElement("span", {}, text_1);
            let penIconHtml_1;
            if (enableEarliestInvoiceDateChangeState[0]) {
                penIconHtml_1 = react.createElement(react.Fragment, {});
            }
            else {
                const children_34 = [getMaterialIcon("edit")];
                penIconHtml_1 = react.createElement("div", {
                    id: "earliest-invoice-date-pen",
                    className: "billed-to__pen-icon",
                    onClick: (_arg_3) => {
                        enableEarliestInvoiceDateChangeState[1](true);
                        const matchValue_7 = [earliestInvoiceDateState[0], earliestInvoiceDateOptions];
                        let pattern_matching_result_1;
                        if (matchValue_7[0] === "") {
                            if (!isEmpty(matchValue_7[1])) {
                                pattern_matching_result_1 = 0;
                            }
                            else {
                                pattern_matching_result_1 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                        switch (pattern_matching_result_1) {
                            case 0: {
                                earliestInvoiceDateState[1](head_3(matchValue_7[1])[0]);
                                break;
                            }
                            case 1: {
                                break;
                            }
                        }
                    },
                }, ...children_34);
            }
            let chooserHtml_1;
            const matchValue_8 = enableEarliestInvoiceDateChangeState[0];
            chooserHtml_1 = (matchValue_8 ? selectOption((inputRecord_2 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_3(0, earliestInvoiceDateState[0], (e_1) => {
                const arg_12 = Browser_Types_Event__Event_get_Value(e_1);
                earliestInvoiceDateState[1](arg_12);
            }), "earliest-invoice-date-selector", earliestInvoiceDateOptions, inputRecord_2.Classes, inputRecord_2.LabelText, equals(radioChoiceState[0], new RadioChoice(0)) ? true : equals(radioChoiceState[0], new RadioChoice(2)), inputRecord_2.HTMLProps))) : react.createElement(react.Fragment, {}));
            earliestInvoiceDateHtml = primary(panelHeaderHtml_1, panelBodyHtml_1, (children_39 = [invoicedToTextHtml_1, earliestInvoiceDateTextHtml, penIconHtml_1, react.createElement("div", {
                className: "fit-content",
            }, chooserHtml_1)], react.createElement("div", {
                className: "billed-to__container-horizontal",
            }, ...children_39)));
            break;
        }
        default: {
            earliestInvoiceDateHtml = react.createElement(react.Fragment, {});
        }
    }
    let maxBilledToNextTimeHtml;
    const matchValue_9 = maxBilledToNextTimeLoadState[0];
    switch (matchValue_9.tag) {
        case 1: {
            maxBilledToNextTimeHtml = dotsLoading;
            break;
        }
        case 3: {
            maxBilledToNextTimeHtml = error(matchValue_9.fields[0].split(""));
            break;
        }
        case 2: {
            let panelHeaderHtml_2;
            const children_42 = [getTranslation("Containers.FeesTable.MaxBilledToNextTimeInfoText1")];
            panelHeaderHtml_2 = react.createElement("span", {
                className: "font-weight-bold",
            }, ...children_42);
            let panelBodyHtml_2;
            const children_46 = [(children_44 = [getTranslation("Containers.FeesTable.MaxBilledToNextTimeInfoText2")], react.createElement("p", {}, ...children_44))];
            panelBodyHtml_2 = react.createElement("div", {}, ...children_46);
            let invoicedToTextHtml_2;
            const children_48 = [getTranslation("Containers.FeesTable.MaxBilledToNextTime") + ": "];
            invoicedToTextHtml_2 = react.createElement("span", {}, ...children_48);
            let maxBilledToNextTimeTextHtml;
            const text_2 = defaultArg(map(DateOnlyExtensions_yyyy_MM_dd, matchValue_9.fields[0]), (arg_13 = getTranslation("Containers.FeesTable.NotSet"), toText(printf("(%s)"))(arg_13)));
            maxBilledToNextTimeTextHtml = react.createElement("span", {}, text_2);
            let penIconHtml_2;
            if (enableMaxBilledToNextTimeChangeState[0]) {
                penIconHtml_2 = react.createElement(react.Fragment, {});
            }
            else {
                const children_53 = [getMaterialIcon("edit")];
                penIconHtml_2 = react.createElement("div", {
                    id: "max-billed-to-next-time-pen",
                    className: "billed-to__pen-icon",
                    onClick: (_arg_4) => {
                        enableMaxBilledToNextTimeChangeState[1](true);
                        const matchValue_11 = [maxBilledToNextTimeState[0], maxBilledToNextTimeOptions];
                        let pattern_matching_result_2;
                        if (matchValue_11[0] === "") {
                            if (!isEmpty(matchValue_11[1])) {
                                pattern_matching_result_2 = 0;
                            }
                            else {
                                pattern_matching_result_2 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                        switch (pattern_matching_result_2) {
                            case 0: {
                                maxBilledToNextTimeState[1](head_3(matchValue_11[1])[0]);
                                break;
                            }
                            case 1: {
                                break;
                            }
                        }
                    },
                }, ...children_53);
            }
            let chooserHtml_2;
            const matchValue_12 = enableMaxBilledToNextTimeChangeState[0];
            chooserHtml_2 = (matchValue_12 ? selectOption((inputRecord_3 = SelectOption_get_getDefault(), new SelectOption(new ValueProp_3(0, maxBilledToNextTimeState[0], (e_2) => {
                const arg_14 = Browser_Types_Event__Event_get_Value(e_2);
                maxBilledToNextTimeState[1](arg_14);
            }), "max-billed-to-next-time-selector", maxBilledToNextTimeOptions, inputRecord_3.Classes, inputRecord_3.LabelText, equals(radioChoiceState[0], new RadioChoice(0)) ? true : equals(radioChoiceState[0], new RadioChoice(1)), inputRecord_3.HTMLProps))) : react.createElement(react.Fragment, {}));
            maxBilledToNextTimeHtml = primary(panelHeaderHtml_2, panelBodyHtml_2, (children_58 = [invoicedToTextHtml_2, maxBilledToNextTimeTextHtml, penIconHtml_2, react.createElement("div", {
                className: "fit-content",
            }, chooserHtml_2)], react.createElement("div", {
                className: "billed-to__container-horizontal",
            }, ...children_58)));
            break;
        }
        default: {
            maxBilledToNextTimeHtml = react.createElement(react.Fragment, {});
        }
    }
    let radioContainerHtml;
    const billedToClasses = classNames(ofArray([["ml-4", true], ["mb-4", true], ["billed-to__fade", !equals(radioChoiceState[0], new RadioChoice(0))]]));
    const earliestInvoiceDateClasses = classNames(ofArray([["ml-4", true], ["billed-to__fade", !equals(radioChoiceState[0], new RadioChoice(1))]]));
    const maxBilledToNextTimeClasses = classNames(ofArray([["ml-4", true], ["billed-to__fade", !equals(radioChoiceState[0], new RadioChoice(2))]]));
    const children_66 = [inputRadio((inputRecord_4 = RadioInput_get_getDefault(), (RadioValue = RadioChoice_get_ToString()(new RadioChoice(0)), (IsChecked = equals(radioChoiceState[0], new RadioChoice(0)), new RadioInput("billed-to-radio-choice-1", "radio-choice-group", (e_3) => {
        radioChoiceState[1](RadioChoice_get_FromString()(Browser_Types_Event__Event_get_Value(e_3)));
    }, RadioValue, getTranslation("Containers.FeesTable.ChangeBilledTo"), IsChecked, inputRecord_4.Disabled))))), react.createElement("div", {
        className: billedToClasses,
    }, billedToHtml), inputRadio((inputRecord_5 = RadioInput_get_getDefault(), (RadioValue_1 = RadioChoice_get_ToString()(new RadioChoice(1)), (IsChecked_1 = equals(radioChoiceState[0], new RadioChoice(1)), new RadioInput("billed-to-radio-choice-2", "radio-choice-group", (e_4) => {
        radioChoiceState[1](RadioChoice_get_FromString()(Browser_Types_Event__Event_get_Value(e_4)));
    }, RadioValue_1, getTranslation("Containers.FeesTable.SetEarliestInvoiceDate"), IsChecked_1, inputRecord_5.Disabled))))), react.createElement("div", {
        className: earliestInvoiceDateClasses,
    }, earliestInvoiceDateHtml), inputRadio((inputRecord_6 = RadioInput_get_getDefault(), (RadioValue_2 = RadioChoice_get_ToString()(new RadioChoice(2)), (IsChecked_2 = equals(radioChoiceState[0], new RadioChoice(2)), new RadioInput("billed-to-radio-choice-3", "radio-choice-group", (e_5) => {
        radioChoiceState[1](RadioChoice_get_FromString()(Browser_Types_Event__Event_get_Value(e_5)));
    }, RadioValue_2, getTranslation("Containers.FeesTable.SetMaxBilledToNextTime"), IsChecked_2, inputRecord_6.Disabled))))), react.createElement("div", {
        className: maxBilledToNextTimeClasses,
    }, maxBilledToNextTimeHtml)];
    radioContainerHtml = react.createElement("div", {
        className: "billed-to__container-vertical",
    }, ...children_66);
    bodyHtml = react.createElement("div", {
        className: "fees__billed-to",
    }, radioContainerHtml);
    const cancelButtonProps = new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_5) => {
        props.CloseModalFn();
    }, defaultProps.Disabled, "billed-to-modal-cancel-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    const acceptButtonProps = new ButtonProps(getTranslation("Common.Save"), defaultProps.Content, (_arg_6) => {
        let matchValue_15, matchValue_16, matchValue_14;
        const matchValue_13 = radioChoiceState[0];
        switch (matchValue_13.tag) {
            case 1: {
                props.SaveEarliestInvoiceDateFn((matchValue_15 = (earliestInvoiceDateState[0]), (matchValue_15 === "") ? (void 0) : parse_1(matchValue_15)));
                break;
            }
            case 2: {
                props.SaveMaxBilledToNextTimeFn((matchValue_16 = (maxBilledToNextTimeState[0]), (matchValue_16 === "") ? (void 0) : parse_1(matchValue_16)));
                break;
            }
            default: {
                props.SaveBilledToFn((matchValue_14 = (billedToDateState[0]), (matchValue_14 === "") ? (void 0) : parse_1(matchValue_14)));
            }
        }
        props.CloseModalFn();
    }, defaultProps.Disabled, "billed-to-modal-accept-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    return renderWithButtonProps(true, new ModalSize(2), getTranslation("Containers.FeesTable.FeeInvoicing"), bodyHtml, cancelButtonProps, acceptButtonProps);
}, "billedToModal", uncurry(2, void 0), void 0, "renderEditInvoicingModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FeesTable\\View.fs", 901);

export class CreateFeeProps extends Record {
    constructor(FeeTemplates, ChartOfAccounts, UseAccountNo, MonthsInAdvance, ContractTypeCode, ProductNr, Locale, CountryCode, PaymentMethod, MaxFee, OnCreateClick, FeeVersion, FeeType, UsesUnitPrice) {
        super();
        this.FeeTemplates = FeeTemplates;
        this.ChartOfAccounts = ChartOfAccounts;
        this.UseAccountNo = UseAccountNo;
        this.MonthsInAdvance = (MonthsInAdvance | 0);
        this.ContractTypeCode = ContractTypeCode;
        this.ProductNr = ProductNr;
        this.Locale = Locale;
        this.CountryCode = CountryCode;
        this.PaymentMethod = PaymentMethod;
        this.MaxFee = MaxFee;
        this.OnCreateClick = OnCreateClick;
        this.FeeVersion = FeeVersion;
        this.FeeType = FeeType;
        this.UsesUnitPrice = UsesUnitPrice;
    }
}

export function CreateFeeProps$reflection() {
    return record_type("Containers.FeesTable.View.CreateFeeProps", [], CreateFeeProps, () => [["FeeTemplates", list_type(FeeFormTemplate$reflection())], ["ChartOfAccounts", list_type(ChartOfAccount$reflection())], ["UseAccountNo", bool_type], ["MonthsInAdvance", int32_type], ["ContractTypeCode", option_type(string_type)], ["ProductNr", option_type(int32_type)], ["Locale", Locale$reflection()], ["CountryCode", IsoCountryCode$reflection()], ["PaymentMethod", PaymentMethod$reflection()], ["MaxFee", option_type(class_type("System.Decimal"))], ["OnCreateClick", lambda_type(FeeFormViewModelValues$reflection(), unit_type)], ["FeeVersion", FeeVersion$reflection()], ["FeeType", FeeType$reflection()], ["UsesUnitPrice", bool_type]]);
}

export const renderCreateFeeButton = FunctionComponent_Of_Z5A158BBF((props) => {
    let _arg, _arg_1;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const createFeeModalOpenState = react.useState(false);
    let feeConfig_1;
    const matchValue = props.FeeVersion;
    let pattern_matching_result, feeConfig;
    if (matchValue.tag === 1) {
        pattern_matching_result = 0;
        feeConfig = matchValue.fields[0];
    }
    else {
        pattern_matching_result = 0;
        feeConfig = matchValue.fields[0];
    }
    switch (pattern_matching_result) {
        case 0: {
            feeConfig_1 = feeConfig;
            break;
        }
    }
    let initFeeViewModelValues;
    const initFeeViewModel = getInitFeeViewModelValues(getTranslation, props.FeeVersion, feeConfig_1.DefaultMonthsInAdvance, feeConfig_1.DefaultCancellationPeriodMonths);
    const SelectedMonthsInAdvance = ((props.FeeVersion.tag === 1) ? initFeeViewModel.SelectedMonthsInAdvance : props.MonthsInAdvance) | 0;
    initFeeViewModelValues = (new FeeFormViewModelValues(props.FeeTemplates, initFeeViewModel.SelectedTemplate, initFeeViewModel.Description, initFeeViewModel.AmountExclVat, initFeeViewModel.AmountInclVat, initFeeViewModel.BoundMonths, initFeeViewModel.BoundToDate, initFeeViewModel.RemainingBoundMonths, (props.FeeVersion.tag === 1) ? initFeeViewModel.SelectedCancellationPeriod : ((_arg = cancellationPeriodMonths_1(getTranslation), isEmpty(_arg) ? 0 : parse_2(head_3(_arg)[0], 511, false, 32))), SelectedMonthsInAdvance, initFeeViewModel.SelectedPeriod, initFeeViewModel.ChosenCancelledDate, initFeeViewModel.CancelledDate, initFeeViewModel.SelectedAfterSomeTime, initFeeViewModel.StartDate, (_arg_1 = getVatRates(props.CountryCode), isEmpty(_arg_1) ? fromParts(0, 0, 0, false, 0) : head_3(_arg_1)), initFeeViewModel.ValidationError, props.ChartOfAccounts, initFeeViewModel.SelectedAccountNo, props.UseAccountNo, initFeeViewModel.BilledTo, initFeeViewModel.Units));
    let createFeeModalHtml;
    const matchValue_3 = createFeeModalOpenState[0];
    createFeeModalHtml = (matchValue_3 ? renderFeeModal(new FeeModalProps(initFeeViewModelValues, props.ContractTypeCode, props.ProductNr, props.Locale, props.CountryCode, props.PaymentMethod, props.MaxFee, false, () => {
        createFeeModalOpenState[1](false);
    }, (vm) => {
        props.OnCreateClick(vm);
        createFeeModalOpenState[1](false);
    }, props.FeeVersion, props.FeeType)) : react.createElement(react.Fragment, {}));
    const children_1 = [wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Fees.CreateFee"), defaultProps.Content, (_arg_2) => {
        createFeeModalOpenState[1](true);
    }, defaultProps.Disabled, "create-fee-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), createFeeModalHtml];
    return react.createElement("div", {}, ...children_1);
}, void 0, uncurry(2, void 0), void 0, "renderCreateFeeButton", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FeesTable\\View.fs", 987);

export class FeesTableProps extends Record {
    constructor(Fees, FeeTemplates, GlobalDependencies, ProductNr, ContractTypeCode, ChartOfAccounts, PaymentMethod, MonthsInAdvance, MaxFee, SaveEditFeeFn, SaveTerminateFeeFn, SaveAnnulFeeFn, SaveBilledToFn, SaveEarliestInvoiceDateFn, SaveMaxBilledToNextTimeFn, FeeType) {
        super();
        this.Fees = Fees;
        this.FeeTemplates = FeeTemplates;
        this.GlobalDependencies = GlobalDependencies;
        this.ProductNr = ProductNr;
        this.ContractTypeCode = ContractTypeCode;
        this.ChartOfAccounts = ChartOfAccounts;
        this.PaymentMethod = PaymentMethod;
        this.MonthsInAdvance = (MonthsInAdvance | 0);
        this.MaxFee = MaxFee;
        this.SaveEditFeeFn = SaveEditFeeFn;
        this.SaveTerminateFeeFn = SaveTerminateFeeFn;
        this.SaveAnnulFeeFn = SaveAnnulFeeFn;
        this.SaveBilledToFn = SaveBilledToFn;
        this.SaveEarliestInvoiceDateFn = SaveEarliestInvoiceDateFn;
        this.SaveMaxBilledToNextTimeFn = SaveMaxBilledToNextTimeFn;
        this.FeeType = FeeType;
    }
}

export function FeesTableProps$reflection() {
    return record_type("Containers.FeesTable.View.FeesTableProps", [], FeesTableProps, () => [["Fees", list_type(Fee$reflection())], ["FeeTemplates", list_type(FeeFormTemplate$reflection())], ["GlobalDependencies", GlobalDependencies$reflection()], ["ProductNr", option_type(int32_type)], ["ContractTypeCode", option_type(string_type)], ["ChartOfAccounts", list_type(ChartOfAccount$reflection())], ["PaymentMethod", PaymentMethod$reflection()], ["MonthsInAdvance", int32_type], ["MaxFee", option_type(class_type("System.Decimal"))], ["SaveEditFeeFn", lambda_type(tuple_type(Fee$reflection(), FeeFormViewModelValues$reflection()), unit_type)], ["SaveTerminateFeeFn", lambda_type(tuple_type(Fee$reflection(), TerminateFeeDetails$reflection()), unit_type)], ["SaveAnnulFeeFn", lambda_type(Fee$reflection(), unit_type)], ["SaveBilledToFn", lambda_type(int32_type, lambda_type(option_type(class_type("System.DateOnly")), unit_type))], ["SaveEarliestInvoiceDateFn", lambda_type(int32_type, lambda_type(option_type(class_type("System.DateOnly")), unit_type))], ["SaveMaxBilledToNextTimeFn", lambda_type(int32_type, lambda_type(option_type(class_type("System.DateOnly")), unit_type))], ["FeeType", FeeType$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let s_1, matchValue_2, matchValue_3, _arg;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const modalOpenState = react.useState(new Modal(0));
    const expandAreaRowIdState = react.useState(void 0);
    const dotMenu = toList(delay(() => append(singleton([getTranslation("Common.Edit"), (arg_2) => {
        modalOpenState[1](new Modal(1, arg_2));
    }]), delay(() => append(singleton([getTranslation("Containers.FeesTable.Terminate"), (arg_5) => {
        modalOpenState[1](new Modal(2, arg_5));
    }]), delay(() => append(singleton([getTranslation("Containers.FeesTable.AnnulFee"), (arg_8) => {
        modalOpenState[1](new Modal(3, arg_8));
    }]), delay(() => (props.GlobalDependencies.ClientConfig.EnableFeesV2 ? singleton([getTranslation("Containers.FeesTable.ChangeInvocing"), (arg_11) => {
        modalOpenState[1](new Modal(4, arg_11));
    }]) : empty())))))))));
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    let feesTableHtml;
    const matchValue = props.Fees;
    if (isEmpty(matchValue)) {
        const children = [info(getTranslation("Containers.FeesTable.FeesMissing").split(""))];
        feesTableHtml = react.createElement("span", {
            ["data-translation"]: "Containers.FeesTable.FeesMissing",
        }, ...children);
    }
    else {
        feesTableHtml = renderFeesTable(getTranslation, expandAreaRowIdState[0], matchValue, props.FeeTemplates, dotMenu, (newRowId) => {
            expandAreaRowIdState[1]((currentRowIdOpt) => {
                let currentRowId_1;
                return (currentRowIdOpt != null) ? ((currentRowIdOpt === newRowId) ? ((currentRowId_1 = currentRowIdOpt, void 0)) : newRowId) : newRowId;
            });
        }, locale, props.GlobalDependencies.ClientConfig.FeeConfig.UsesUnitPrice, props.GlobalDependencies.ClientNr);
    }
    let feesTableModalHtml;
    const matchValue_1 = modalOpenState[0];
    switch (matchValue_1.tag) {
        case 2: {
            feesTableModalHtml = renderTerminateFeeModal(new TerminateFeeModalProps(getTranslation, parse_2(matchValue_1.fields[0], 511, false, 32), props.Fees, locale, () => {
                modalOpenState[1](new Modal(0));
            }, props.SaveTerminateFeeFn));
            break;
        }
        case 3: {
            feesTableModalHtml = annulFeeModalHtml(getTranslation, parse_2(matchValue_1.fields[0], 511, false, 32), () => {
                modalOpenState[1](new Modal(0));
            }, (feeNr_3) => {
                const matchValue_6 = findFee(props.Fees, feeNr_3);
                if (matchValue_6 == null) {
                    logei("Trying to [SaveAnnulFee] but can not find Fee.");
                }
                else {
                    props.SaveAnnulFeeFn(matchValue_6);
                    modalOpenState[1](new Modal(0));
                }
            });
            break;
        }
        case 4: {
            feesTableModalHtml = defaultArg(map((fee_5) => renderEditInvoicingModal(new EditInvoicingModalProps(fee_5, props.GlobalDependencies.ClientConfig.HasCardPayment, locale, () => {
                modalOpenState[1](new Modal(0));
            }, partialApply(1, props.SaveBilledToFn, [fee_5.FeeNumber]), partialApply(1, props.SaveEarliestInvoiceDateFn, [fee_5.FeeNumber]), partialApply(1, props.SaveMaxBilledToNextTimeFn, [fee_5.FeeNumber]), () => loadEarliestInvoiceDate_1(props.GlobalDependencies.ClientNr, fee_5.FeeNumber), () => loadMaxBilledToNextTime_1(props.GlobalDependencies.ClientNr, fee_5.FeeNumber))), bind((feeNr_4) => tryFind((fee_4) => (fee_4.FeeNumber === feeNr_4), props.Fees), parseInt$(matchValue_1.fields[0]))), warning("Cannot open Change BilledTo modal.".split("")));
            break;
        }
        case 0: {
            feesTableModalHtml = react.createElement(react.Fragment, {});
            break;
        }
        default: {
            const currentEditingFeeOpt = bind((feeNumber) => tryFind((fee) => (fee.FeeNumber === feeNumber), props.Fees), parseInt$(matchValue_1.fields[0]));
            if (currentEditingFeeOpt != null) {
                const fee_1 = currentEditingFeeOpt;
                const isBilled = defaultArg(map((fee_2) => (fee_2.BilledTo != null), currentEditingFeeOpt), false);
                feesTableModalHtml = renderFeeModal(new FeeModalProps(new FeeFormViewModelValues(props.FeeTemplates, defaultArg(map(int32ToString, fee_1.FeeTemplateNr), ""), fee_1.Description, fee_1.UnitPrice, op_Multiply(fee_1.UnitPrice, op_Addition(new Decimal(1), op_Division(fee_1.VatRatePercent, (s_1 = (new Decimal(0)), ((() => {
                    for (let i = 0; i <= (100 - 1); i++) {
                        s_1 = op_Addition(s_1, new Decimal(1));
                    }
                })(), s_1))))), fee_1.BoundMonths, (matchValue_2 = fee_1.BoundToDate, (matchValue_2 == null) ? ((matchValue_3 = (fee_1.BoundMonths | 0), (matchValue_3 === 0) ? (void 0) : addMonths(fee_1.StartDate, matchValue_3))) : matchValue_2), fee_1.RemainingBoundMonths, fee_1.CancellationPeriodMonths, fee_1.MonthsInAdvance, fee_1.Period, (fee_1.CancelledDate == null) ? (new CancelDateChoice(0)) : (new CancelDateChoice(1)), defaultArg(fee_1.CancelledDate, DateModule_today()), (_arg = afterSomeTimeSelects(getTranslation), isEmpty(_arg) ? 0 : parse_2(head_3(_arg)[0], 511, false, 32)), fee_1.StartDate, fee_1.VatRatePercent, new FSharpResult$2(0, void 0), props.ChartOfAccounts, fee_1.AccountNo, props.GlobalDependencies.ClientConfig.UseAccountNo, fee_1.BilledTo, fee_1.Units), props.ContractTypeCode, props.ProductNr, locale, props.GlobalDependencies.CountryCode, props.PaymentMethod, props.MaxFee, isBilled, () => {
                    modalOpenState[1](new Modal(0));
                }, (vm) => {
                    props.SaveEditFeeFn([fee_1, vm]);
                    modalOpenState[1](new Modal(0));
                }, props.GlobalDependencies.ClientConfig.EnableFeesV2 ? (new FeeVersion(1, props.GlobalDependencies.ClientConfig.FeeConfig)) : (new FeeVersion(0, props.GlobalDependencies.ClientConfig.FeeConfig)), props.FeeType));
            }
            else {
                feesTableModalHtml = react.createElement(react.Fragment, {});
            }
        }
    }
    return react.createElement("div", {
        className: "fees-table",
        ["data-regression"]: "subscription-fees-table",
    }, feesTableHtml, feesTableModalHtml);
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FeesTable\\View.fs", 1170);

